export const messagesTermsOfUse = {
    pt: {
        message:{
            deactivateOptIn: "Desativar texto de Opt-in",
            disabled: "Desativado",
            keep: "Manter",
            keepWifeedTerms: "Manter os termos do WiFeed?",
            keepWifeedTermsConfirmation: "Deseja manter os termos do WiFeed ativos?",
            lastChange: "Última alteração",
            name: "Nome *",
            noTermRegistered: "Nenhum termo de uso cadastrado",
            optionalAcceptance: "Aceite Opcional",
            optIn: "Texto de Opt-In *",
            optInOptional: "Texto de Opt-In (opcional)",
            publicationDate: "Data de publicação",
            publishTermsOfUse: "Publicar termos de uso?",
            publishTermsOfUseConfirmation: "Tem certeza que deseja publicar este termo de uso?",
            published: "Publicado",
            registerOptIn: "Cadastrar texto de Opt-in",
            registerTermOfUse: "Cadastrar Termo de Uso",
            termsOfUse: "Termos de Uso *",
            title: "Título",
            titleLabel: "Título (opcional)",
            tooltipName: "Nome de identificação da versão do termo de uso personalizado.",
            tooltipOptionalAcceptance: "Com esta opção habilitada, o usuário pode aceitar os termos de uso sem aceitar o opt-in.",
            tooltipOptIn: "Texto extra para destacar parte dos termos de uso, que contará com um aceite específico para ele. Caso fique vazio, usuário aceitará os termos em uma etapa.",
            tooltipTermsOfUse: "Texto que aparecerá com os regimentos dos termos de uso personalizado.",
            tooltipTitle: "Título apresentado ao usuário. Caso fique vazio, o título será 'Termos de uso'.",
            unpublishTermsOfUse: "Despublicar termos de uso?",
            unpublishTermsOfUseConfirmation: "Tem certeza que deseja despublicar este termo de uso?",

            dataController: 'Controlador de dados',
            dataControllerSave: 'Salvar',
            dataControllerFullName: 'Nome Completo',
            dataControllerRole: 'Cargo',
            dataControllerPhoneNumber: 'Telefone',
            dataControllerBirthdate: 'Data de nascimento',
            dataControllerUpdated: "Controlador de dados atualizado com sucesso!",
            dataControllerUpdatedError: "Algo deu errado, tente novamente!",
            dataControllerInvalidDate: 'Data inválida.',
            dataControllerDateGreaterError: "A data não pode ser maior que a data de hoje."
        }
    },
    es: {
        message:{
            deactivateOptIn:"Desactivar el texto de suscripción",
            disabled:"Desactivado",
            keep:"Mantener",
            keepWifeedTerms:"¿Mantener los términos de WiFeed?",
            keepWifeedTermsConfirmation:"¿Quieres mantener activos los términos de WiFeed o usar solo el tuyo?",
            lastChange:"Ultimo cambio",
            name:"Nombre *",
            noTermRegistered:"No hay término de uso registrado",
            optionalAcceptance:"Aceptar opcional",
            optIn:"Texto de opción *",
            optInOptional:"Texto de suscripción (opcional)",
            publicationDate:"Fecha de publicación",
            publishTermsOfUse:"¿Publicar términos de uso?",
            publishTermsOfUseConfirmation:"¿Estás seguro de que quieres publicar este término de uso?",
            published:"Publicado",
            registerOptIn:"Registre el texto de suscripción",
            registerTermOfUse:"Registre el término de uso",
            termsOfUse:"Terminos de uso *",
            title:"Título",
            titleLabel:"Título (opcional)",
            tooltipName:"Nombre de la identificación de la versión del término de uso personalizado",
            tooltipOptionalAcceptance:"Con esta opción habilitada, el usuario puede aceptar los términos de uso sin aceptar la opción",
            tooltipOptIn:"Texto adicional para resaltar parte de los Términos de uso, que tendrán una aceptación específica para ello. Si está vacío, el usuario aceptará los términos en un paso",
            tooltipTermsOfUse:"Texto que aparecerá con los regimientos de los términos de uso personalizado",
            tooltipTitle:"Título presentado al usuario. Si está vacío, el título será 'Términos de uso'",
            unpublishTermsOfUse:"¿Disfregar los términos de uso?",
            unpublishTermsOfUseConfirmation:"¿Estás seguro de que quieres romper este término de uso?",

            dataController: 'Controlador de datos',
            dataControllerSave: "Guardar",
            dataControllerFullName: "Nombre Completo",
            dataControllerRole: "Cargo",
            dataControllerPhoneNumber: "Teléfono",
            dataControllerBirthdate: "Fecha de Nacimiento",
            dataControllerUpdated: "Controlador de datos actualizado con éxito!",
            dataControllerUpdatedError: "Algo salió mal, ¡intenta de nuevo!",
            dataControllerInvalidDate: 'Fecha no válida.',
            dataControllerDateGreaterError: "La fecha no puede ser mayor que la fecha de hoy."
        }
    },
    en: {
        message:{
            deactivateOptIn: "Deactivate Opt-in text",
            disabled: "Disabled",
            keep: "Keep it",
            keepWifeedTerms: "Keep WiFeed terms?",
            keepWifeedTermsConfirmation: "Do you want to keep the WiFeed terms active or just use yours?",
            lastChange: "Last change",
            name: "Name *",
            noTermRegistered: "No terms of use registered\n",
            optionalAcceptance: "Optional Acceptance",
            optIn: "Opt-In Text *",
            optInOptional: "Opt-In Text (optional)",
            publicationDate: "Publication date",
            publishTermsOfUse: "Publish terms of use?",
            publishTermsOfUseConfirmation: "Are you sure you want to publish this term of use?",
            published: "Published",
            registerOptIn: "Register Opt-in text",
            registerTermOfUse: "Register Term of Use",
            termsOfUse: "Terms of Use *",
            title: "Title",
            titleLabel: "Title (optional)",
            tooltipName: "Custom term of use version identification name.",
            tooltipOptionalAcceptance: "With this option enabled, the user can accept the terms of use without accepting the opt-in.",
            tooltipOptIn: "Extra text to highlight part of the terms of use, which will have a specific acceptance for it. If it is empty, the user will accept the terms in one step.",
            tooltipTermsOfUse: "Text that will appear with the custom terms of use bylaws.",
            tooltipTitle: "Title presented to the user. If empty, the title will be 'Terms of Use'.",
            unpublishTermsOfUse: "Unpublish terms of use?",
            unpublishTermsOfUseConfirmation: "Are you sure you want to unpublish this term of use?",

            dataController: "Data Controller",
            dataControllerSave: "Save",
            dataControllerFullName: "Full Name",
            dataControllerRole: "Role",
            dataControllerPhoneNumber: "Phone",
            dataControllerBirthdate: "Birthdate",
            dataControllerUpdated: "Data controller successfully updated!",
            dataControllerUpdatedError: "Something went wrong, try again!",
            dataControllerInvalidDate: 'Invalid date.',
            dataControllerDateGreaterError: "The date cannot be greater than today's date."
        }
    }
}
